<kendo-badge-container style="margin-right: 8px;">
  <button
    kendoButton
    size="small"
    themeColor="primary"
    [disabled]="pendingSync == 0"
    (click)="schedulerVisible = true"
  >
    Sync
  </button>
  <kendo-badge
    *ngIf="pendingSync > 0"
    size="small"
    rounded="full"
    [align]="{ vertical: 'top', horizontal: 'end' }"
    themeColor="success"
    >{{ pendingSync }}</kendo-badge
  >
</kendo-badge-container>

<app-scheduler
  *ngIf="schedulerVisible"
  (onConfirm)="hideScheduler()"
></app-scheduler>
